export default __webpack_public_path__ + "static/media/cyber-ak.1c7184a4.png";